import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PortalCollapsibleComponent } from '../../portal-collapsible/portal-collapsible.component';
import { BillingAddressDisplayComponent } from '../billing-address-display/billing-address-display.component';
import { BillingAddressEditComponent } from '../billing-address-edit/billing-address-edit.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { CustomerService } from 'app/core/customer/customer.service';
import { filter } from 'rxjs';

@Component({
    selector: 'app-billing-address-collapsible',
    templateUrl: './billing-address-collapsible.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PortalCollapsibleComponent, BillingAddressDisplayComponent, BillingAddressEditComponent],
})
export class BillingAddressCollapsibleComponent {
    private customer$ = inject(CustomerService).customer$.pipe(filter((res) => res !== null));
    protected customer = toSignal(this.customer$);

    protected editMode = false;

    protected toggleEditMode(): void {
        this.editMode = !this.editMode;
    }
}
